var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Notification, { prefixCls } from "./Notification";
import classNames from "classnames";
import Panel from "./Panel";
var defaultDuration = 4.5;
var defaultTop = 24;
var defaultBottom = 24;
var defaultGetContainer;
var rtl = false;
var maxCount = 5;
export var Notify = function (props) {
    var _a;
    var _b = props.placement, placement = _b === void 0 ? "topRight" : _b, _c = props.duration, duration = _c === void 0 ? defaultDuration : _c, description = props.description, title = props.title, type = props.type, icon = props.icon, _d = props.closable, closable = _d === void 0 ? true : _d;
    var contentPanel = Panel({ icon: icon, type: type, title: title, description: description });
    var noticeProps = {
        content: contentPanel,
        duration: duration,
        closable: closable,
    };
    var notificationInstance = {};
    var getContainer = defaultGetContainer;
    var top = defaultTop;
    var bottom = defaultBottom;
    var notificationClass = classNames("".concat(prefixCls, "-").concat(placement), (_a = {},
        _a["".concat(prefixCls, "-rtl")] = rtl,
        _a));
    var cacheKey = "".concat(prefixCls, "-").concat(placement);
    notificationInstance[cacheKey] = new Promise(function (resolve) {
        Notification.newInstance({
            prefixCls: prefixCls,
            className: notificationClass,
            style: getPlacementStyle(placement, top, bottom),
            getContainer: getContainer,
            maxCount: maxCount,
        }, function (notification) {
            notification.notice(noticeProps);
            resolve(notification);
        });
    });
};
var getPlacementStyle = function (placement, top, bottom) {
    if (top === void 0) { top = defaultTop; }
    if (bottom === void 0) { bottom = defaultBottom; }
    var style;
    switch (placement) {
        case "top":
            style = {
                left: "50%",
                transform: "translateX(-50%)",
                right: "auto",
                top: top,
                bottom: "auto",
            };
            break;
        case "topLeft":
            style = {
                left: 0,
                top: top,
                bottom: "auto",
            };
            break;
        case "topRight":
            style = {
                right: 0,
                top: top,
                bottom: "auto",
            };
            break;
        case "bottom":
            style = {
                left: "50%",
                transform: "translateX(-50%)",
                right: "auto",
                top: "auto",
                bottom: bottom,
            };
            break;
        case "bottomLeft":
            style = {
                left: 0,
                top: "auto",
                bottom: bottom,
            };
            break;
        default:
            style = {
                right: 0,
                top: "auto",
                bottom: bottom,
            };
            break;
    }
    return style;
};
export default {
    success: function (props) {
        Notify(__assign(__assign({}, props), { type: "success" }));
    },
    error: function (props) {
        Notify(__assign(__assign({}, props), { type: "error" }));
    },
    warning: function (props) {
        Notify(__assign(__assign({}, props), { type: "warning" }));
    },
    info: function (props) {
        Notify(__assign(__assign({}, props), { type: "info" }));
    },
    open: function (props) {
        Notify(__assign({}, props));
    },
};
